<template>
  <transition name="app-modal">
    <div class="app-modal">
      <div class="app-modal__wrapper">
        <div class="app-modal__container">

          <slot />

          <div class="app-modal__actions">
            <app-btn
              v-for="(action, index) in renderActions"
              :key="index"
              @click.native.prevent="action.cta"
              :text="action.text"
              ref="button"
            />
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import eventBus from '@/event-bus';

import Button from '@/components/UI/Button.vue';

export default {
  name: 'Modal',
  data() {
    return {
      defaultActions: [],
    };
  },
  components: {
    appBtn: Button,
  },
  props: {
    actions: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  created() {
    const vm = this;
    this.defaultActions.push({
      text: 'Try Again',
      cta: () => {
        eventBus.$emit('tryAgain');
        vm.$emit('close');
      },
    });
  },
  computed: {
    renderActions() {
      return this.actions.length ? this.actions : this.defaultActions;
    },
  },
};
</script>
